/* eslint-env node es2020 */

/*!
 * Copyright (c) 2022 by DCCS GmbH. All rights reserved.
 */

// eslint-disable-next-line no-undef
__webpack_public_path__ =
    process.env.NODE_ENV === 'production' && window.ams && window.ams.cdnFrontendLoaderUrl
        ? window.ams.cdnFrontendLoaderUrl
        : '/o/ams-osram-frontend-loader/assets/';

require('./bootstrap');

if (document.querySelector('[data-lazyload]')) {
    import(/* webpackChunkName: "lazyload" */ './components/lazy-load-source.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the component `Lazy Load Source`', error));
}

if (
    document.querySelector(
        '[id^="fragment-"] a[href^="/"]:not([href^="/en/"]):not([href^="/zh/"]):not([href^="/ja/"]):not([href^="/ko/"]):not([href^="/de/"]):not([href^="/documents/"])'
    )
) {
    import(/* webpackChunkName: "prepend-locale-to-links" */ './components/prepend-locale-to-links.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the prepend locales script!`', error));
}

if (document.querySelector('.main-navigation')) {
    import(/* webpackChunkName: "navigation" */ './components/navigation.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the navigation script!`', error));
}

if (document.querySelector('.main-navigation-searchview')) {
    import(/* webpackChunkName: "navigation" */ './components/quicksearch.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the quicksearch script!`', error));
}

if (document.querySelector('.article-video, .two-column.has-video, .hero.has-video')) {
    import(/* webpackChunkName: "video" */ './components/video.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Video fragment script!`', error));
}
if (document.querySelector('.collapsable')) {
    import(/* webpackChunkName: "collapsable" */ './components/collapsable.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Collapsable fragment script!`', error));
}

if (document.querySelectorAll('[data-tracking="true"]')) {
    import(/* webpackChunkName: "tracking" */ './components/tracking.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Tracking script!`', error));
}

if (document.querySelector('.slider-container')) {
    import(/* webpackChunkName: "slider" */ './components/slider.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Slider fragment script!`', error));
}

if (document.querySelector('.dccs-form')) {
    import(/* webpackChunkName: "dccs-form" */ './components/DccsForm/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `DCCSForm`', error));
}
localStorage['formsLoaded'] = false;
if (document.querySelector('.contact-form')) {
    import(/* webpackChunkName: "dccs-contact-form" */ './components/DccsForm/contact-form.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Contact form`!', error));
}

if (document.querySelector('.support-form')) {
    import(/* webpackChunkName: "dccs-support-form" */ './components/DccsForm/support-form.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Support form`!', error));
}

if (document.querySelector('#newsletterForm')) {
    import(/* webpackChunkName: "dccs-newsletter-form" */ './components/DccsForm/newsletter-form.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Newsletter form`!', error));
}

if (document.querySelector('.dccs-form-wrapper')) {
    import(/* webpackChunkName: "dccs-form" */ './components/DccsForm/loading-forms.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `DCCSForms loading`', error));
}

if (document.getElementById('app-download-center')) {
    import(/* webpackChunkName: "download-center" */ './components/DownloadCenter/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app DownloadCenter!', error));
}

if (document.getElementById('app-document-upload')) {
    import(/* webpackChunkName: "document-upload" */ './components/DocumentUpload/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app DocumentUpload!', error));
}

if (document.getElementById('support-form')) {
    import(/* webpackChunkName: "support-form" */ './components/SupportForm/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app SupportForm!', error));
}

if (document.getElementById('app-product-user-mapping')) {
    import(/* webpackChunkName: "product-user-mapping" */ './components/ProductUserMapping/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app ProductUserMapping!', error));
}

if (document.querySelector('.product-hero')) {
    import(/* webpackChunkName: "product-hero-image-gallery" */ './components/product-hero-image-gallery.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the product-hero-image-gallery module!', error));
}

if (document.querySelector('.ecom-specific')) {
    import(/* webpackChunkName: "product-hero-image-gallery" */ './components/ecom-specific.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the product-hero-image-gallery module!', error));
}

if (document.querySelector('#content .breadcrumbs .breadcrumb')) {
    import(/* webpackChunkName: "breadcrumbs" */ './components/breadcrumbs.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the breadcrumbs module!', error));
}

if (document.getElementById('app-partner-network')) {
    import(/* webpackChunkName: "partner-network" */ './components/PartnerNetwork/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app PartnerNetwork!', error));
}

if (document.getElementById('ingredient-branding')) {
    import('./components/IngredientBranding/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app IngredientBranding!', error));
}

if (document.querySelector('#wrapper')) {
    import(/* webpackChunkName: "open-graph-image" */ './components/open-graph-image.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the open-graph-image script!', error));
}

// LEGACY STUFF

window.ams = window.ams || {};
window.ams.initToggleOnButtonClick = (buttonId, defaultLabel, newLabel) => {
    import('./legacy/toggle-content-button.js')
        .then(module => {
            module.default(buttonId, defaultLabel, newLabel);
        })
        .catch(error => console.error('An error occurred while loading the component `ToggleContentButton`', error));
};

window.ams.formatDisplayDateHelper = (string, locale) => {
    return import('./helpers/formatDisplayDate.js').then(module => module.default(string, locale));
};

if (
    document.getElementById('app-search-page') ||
    document.querySelector('#app-search-product-list, .app-search-product-list')
) {
    import(/* webpackChunkName: "search" */ './components/Search/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while trying to load the search application.', error));
}

if (document.getElementById('news-hub-container')) {
    import(/* webpackChunkName: "news-hub" */ './components/NewsHub/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while loading the NewsHub application.', error));
}

if (document.getElementById('account-address')) {
    import(/* webpackChunkName: "account-address" */ './components/AccountAddress/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app AccountAddress!', error));
}

if (document.getElementById('buy-now')) {
    import(/* webpackChunkName: "quote-list" */ './components/BuyNow/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app BuyNow!', error));
}

if (document.getElementById('quote-list')) {
    import(/* webpackChunkName: "quote-list" */ './components/Quote/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Quote!', error));
}
if (document.getElementById('delivery-list')) {
    import(/* webpackChunkName: "quote-list" */ './components/Delivery/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Delivery!', error));
}
if (document.getElementById('delivery-price-check')) {
    import('./components/DeliveryPriceCheck/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Delivery Price Check!', error));
}

if (document.getElementById('invoice-list')) {
    import(/* webpackChunkName: "invoice-list" */ './components/Invoice/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Invoice!', error));
}

if (document.getElementById('my-account')) {
    import(/* webpackChunkName: "invoice-list" */ './components/MyAccount/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app My account!', error));
}

if (document.getElementById('credit-list')) {
    import(/* webpackChunkName: "credit-list" */ './components/Credit/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Credit!', error));
}

if (document.getElementById('debit-list')) {
    import(/* webpackChunkName: "debit-list" */ './components/Debit/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Debit!', error));
}

if (document.getElementById('order-list')) {
    import('./components/Order/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Order list!', error));
}

if (document.getElementById('price-list')) {
    import('./components/PriceList/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app Price list!', error));
}

if (document.querySelector('a[data-gated-content]')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/convert-gated-content-links.js')
        .then(module => module.default())
        .catch(error =>
            console.error('An error occurred while trying to load the gated content link conversion module.', error)
        );
}

if (document.querySelector('[data-request-document-download]')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/request-document-download.js')
        .then(module => module.default())
        .catch(error =>
            console.error(
                'An error occurred while trying to load the document download event dispatcher module.',
                error
            )
        );
}

if (document.getElementById('app-document-download-approval')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/document-download-approval/index.js')
        .then(module => module.default())
        .catch(error =>
            console.error('An error occurred while trying to load the document download approval module.', error)
        );
}

if (document.getElementById('app-gated-content-form')) {
    import(/* webpackChunkName: "gated-content" */ './legacy/gated-content/index.js')
        .then(module => module.default())
        .catch(error => console.error('An error occurred while trying to load the gated content module.', error));
}

/** This snippet loads legacy styles for old ams.com components if they are detected on the page. */
if (
    document.querySelector(
        '.journal-content-article .banner, .journal-content-article .blog-entry, .g-edit-button, .portlet-asset-publisher .cards--no-padding > .container > .cards__content.row, .portlet-asset-publisher .cards .cards__content.row, .microsite-banner, .ms-cards, .journal-content-article .ms-newsletter, .journal-content-article .info-detail, #news-hub-container, .newsletter-form, div[id^="fragment-"] > .product, .st-article, .journal-content-article .tcc, body[class*="page-about-usinvestor-relations"]'
    )
) {
    import(/* webpackChunkName: "legacy" */ '../scss/legacy.scss').catch(error =>
        console.error('Could not load legacy styles!', error)
    );
}

if (document.querySelector('.sub-navigation')) {
    import(/* webpackChunkName: "slider" */ './components/sub-navigation.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Sub Navigation script!`', error));
}

if (document.getElementById('app-cart')) {
    import(/* webpackChunkName: "shop" */ './components/Shop/Cart/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the cart 🛒 module!`', error));
}

if (document.getElementById('app-my-orders')) {
    import(/* webpackChunkName: "myOrders" */ './components/Shop/MyOrders/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the myOrders module!`', error));
}

if (document.querySelector('.product-hero')) {
    import(/* webpackChunkName: "product-hero" */ './components/favorites.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Favorites`!', error));
}

if (document.querySelector('.product-hero.has-datasheets')) {
    import(/* webpackChunkName: "product-hero" */ './components/datasheets-popup.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `Datasheets Popup`!', error));
}

if (document.getElementById('app-favorite')) {
    import(/* webpackChunkName: "favorite-list" */ './components/FavoriteList/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the app FavoriteList!', error));
}

if (document.getElementById('ai-search')) {
    import(/* webpackChunkName: "ai-search" */ './components/AiSearch/index')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the AI Search', error));
}

if (document.querySelector('.slider-content')) {
    import(/* webpackChunkName: "slider-content" */ './components/sliderContent.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the component `SliderContent`!', error));
}
if (
    document.querySelector(
        '.card-background-video-desktop, .card-background-video-tablet, .card-background-video-mobile'
    )
) {
    import(/* webpackChunkName: "video" */ './components/background-video.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Background-Video fragment script!`', error));
}
if (document.getElementById('dangerous-goods-download')) {
    import(/* webpackChunkName: "dangerous-goods" */ './components/dangerous-goods-download.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Dangerous goods script!`', error));
}
window.addEventListener('load', function () {
    import(/* webpackChunkName: "header-tooltip" */ './components/header-tooltip.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Header-Tooltip fragment script!`', error));
});

if (document.getElementById('app-product-ordering-codes')) {
    import(/* webpackChunkName: "ProductOrderingCodes" */ './components/ProductOrderingCodes/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the ProductOrderingCodes module!`', error));
}

if (document.getElementById('app-product-download')) {
    import(/* webpackChunkName: "product-download" */ './components/ProductDownload/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the ProductDownload module!`', error));
}

if (document.getElementById('product-packaging')) {
    import('./components/product-packaging.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Product packaging fragment script!`', error));
}

if (document.getElementById('account-statement')) {
    import(/* webpackChunkName: "account-statement" */ './components/AccountStatement/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the AccountStatement module!`', error));
}
if (document.getElementById('category-hierarchy')) {
    import(/* webpackChunkName: "category-hierarchy" */ './components/CategoryHierarchy/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the CategoryHierarchy module!`', error));
}
if (document.querySelector('[data-global-popup-id]')) {
    import('./components/GlobalPopup/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Global popup module!`', error));
}
if(document.querySelector('#cart-detail')) {
    import( './components/Cart/index.js')
        .then(module => {
            module.default();
        })
        .catch(error => console.error('An error occurred while loading the Cart module!', error));
}

if (process.env.NODE_ENV !== 'production') {
    window.Liferay.Icons.controlPanelSpritemap = '/o/admin-theme/images/clay/icons.svg';
    window.Liferay.Icons.spritemap = '/o/ams-osram-theme/images/clay/icons.svg';
    const portalUrl = `${window.Liferay.ThemeDisplay.getPortalURL()}/`;

    const anchors = document.querySelectorAll(`a[href^="${portalUrl}"]`);
    anchors?.forEach(a => {
        a.href = a.href.replace(portalUrl, '/');
    });

    const forms = document.querySelectorAll(`form[action^="${portalUrl}"]`);
    forms?.forEach(f => {
        f.action = f.action.replace(portalUrl, '/');
    });

    const svgUses = document.querySelectorAll(`use`);
    svgUses?.forEach(use => {
        const href = use.getAttribute('xlink:href') || use.getAttribute('href');
        if (href && href.startsWith(portalUrl)) {
            use.setAttribute('xlink:href', href.replace(portalUrl, '/'));
            use.setAttribute('href', href.replace(portalUrl, '/'));
        }
    });
}
